import { PrefixUrlFilter } from '../../SessionUrlFilters/PrefixUrlFilter.mjs'
import { ContainsUrlFilter } from '../../SessionUrlFilters/ContainsUrlFilter.mjs'
import { ExactUrlFilter } from '../../SessionUrlFilters/ExactUrlFilter.mjs'

export function createDefaultFilters() {
  const filters = []
  filters.push(
    new ExactUrlFilter({ value: 'about:blank' }).toJson(),
    new PrefixUrlFilter({ value: 'chrome://' }).toJson(),
    new PrefixUrlFilter({ value: 'chrome-extension://' }).toJson(),
    new PrefixUrlFilter({ value: 'https://app.learnics.com/' }).toJson(),
    new PrefixUrlFilter({
      value: 'https://classroom.google.com/',
    }).toJson(),
    new ContainsUrlFilter({ value: 'schoology.com' }).toJson(),
  )
  return filters
}
